/* Restore product media for image-less PDP variants; leave native variant state alone. */
(() => {
  'use strict';

  const originals = new WeakMap();
  const galleries = () => document.querySelectorAll('hdt-product-media');

  function capture(gallery) {
    if (originals.has(gallery)) return originals.get(gallery);
    // Native Liquid emits product.media in original order, independently of variant.
    const media = gallery.querySelector('.hdt-product-media__main [data-media-id]');
    if (!media) return null;
    const defaultId = media.getAttribute('data-media-id');
    const visibility = Array.from(gallery.querySelectorAll('[data-media-id]'), node => ({
      // A deep-linked media group may initially hide the product's first media.
      // Its main slide and matching thumbnail must be reachable on default reset.
      node, hidden: node.getAttribute('data-media-id') === defaultId ? false : node.hidden
    }));
    const original = { media, visibility };
    originals.set(gallery, original);
    return original;
  }

  function captureAll() {
    galleries().forEach(capture);
  }

  captureAll();
  document.addEventListener('shopify:section:load', captureAll);
  // Capture newly inserted galleries before native form listeners alter media groups.
  document.addEventListener('variant:change', captureAll, true);
  document.addEventListener('variant:change', event => {
    const variant = event.detail?.variant;
    if (!variant || variant.mdid || variant.featured_media || variant.featured_image ||
        event.detail.jumpMedia === false) return;

    galleries().forEach(gallery => {
      // The form's input[name="id"] shadows HTMLFormElement.id in this theme.
      if (gallery.getAttribute('form') !== event.target.getAttribute('id')) return;
      const original = capture(gallery);
      const slider = gallery.sliderMain;
      if (!original || !slider) return;

      const reverseAttribute = 'update-when-variant-change';
      const reverseValue = gallery.getAttribute(reverseAttribute);
      // K5/Embla emits select synchronously during goToTarget. Keep its thumbnail,
      // zoom and playback handlers, but prevent this reset selecting another variant.
      gallery.removeAttribute(reverseAttribute);
      try {
        let changed = false;
        original.visibility.forEach(({ node, hidden }) => {
          if (node.hidden !== hidden) { node.hidden = hidden; changed = true; }
        });
        if (changed) { slider.reInit(); gallery.sliderThumb?.reInit(); }
        if (slider.isActive) slider.goToTarget(original.media, true);
        else original.media.scrollIntoView({ block: 'start', behavior: 'instant' });
      } finally {
        if (reverseValue !== null) gallery.setAttribute(reverseAttribute, reverseValue);
      }
    });
  });
})();
